export const RecommendationType = Object.freeze({
  InsertionOrderCreation: 228,
  InsertionOrderUpdate: 229,
  AutoRecharge: 258,
  RecurringInsertionOrderAdd: 358,
  InsertionOrderInlineSmartness: 395,
});
